interface EmptyStateProps {
  icon: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionIcon?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon,
  title,
  description,
  actionLabel,
  actionIcon,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-14 px-6 text-center">
      <div className="w-16 h-16 rounded-full bg-background-200 flex items-center justify-center mb-4">
        <i className={`${icon} text-3xl text-foreground-400`} />
      </div>
      <p className="text-base font-semibold text-foreground-900">{title}</p>
      {description ? (
        <p className="mt-1.5 text-sm text-foreground-500 max-w-[240px]">{description}</p>
      ) : null}
      {actionLabel && onAction ? (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 flex items-center justify-center gap-2 rounded-2xl bg-primary-500 px-5 py-3 text-[14px] font-semibold text-background-50 shadow-card transition-transform active:scale-[0.99]"
        >
          {actionIcon ? <i className={`${actionIcon} text-lg`} /> : null}
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}